import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal",
  tabindex: "-1"
}
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = { class: "modal-body" }
const _hoisted_4 = {
  key: 0,
  class: "error-message"
}
const _hoisted_5 = { class: "add-row" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "types-table" }
const _hoisted_8 = {
  key: 0,
  class: "empty-state"
}
const _hoisted_9 = {
  class: "col-name",
  "data-label": "Name"
}
const _hoisted_10 = ["onKeyup"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = {
  class: "col-active",
  "data-label": "Active"
}
const _hoisted_13 = ["checked", "onChange"]
const _hoisted_14 = { class: "modal-footer" }
const _hoisted_15 = ["disabled"]

import { ref } from 'vue'
import LookupDataService from '../services/LookupDataService'


export default /*@__PURE__*/_defineComponent({
  __name: 'EventTypesModal',
  props: {
    baseUrl: {}
  },
  emits: ["close", "changed"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const isModalVisible = ref(false)
const eventTypes = ref<any[]>([])
const newTypeName = ref('')
const editingId = ref<number | null>(null)
const editingName = ref('')
const isSaving = ref(false)
const errorMessage = ref('')

const emit = __emit

function authHeaders() {
  return {
    Authorization: `Bearer ${localStorage.token}`,
    'Content-Type': 'application/json'
  }
}

async function loadEventTypes() {
  try {
    const res = await fetch(props.baseUrl + 'EventTypes/GetAll', {
      method: 'GET',
      headers: authHeaders()
    })
    const result = await res.json()
    if (res.ok) {
      eventTypes.value = result.eventTypes || []
    } else {
      errorMessage.value = result.responseMessage || 'Failed to load event types.'
    }
  } catch (e) {
    console.error('Failed to load event types:', e)
    errorMessage.value = 'Failed to load event types.'
  }
}

function openModal() {
  errorMessage.value = ''
  newTypeName.value = ''
  editingId.value = null
  loadEventTypes()
  isModalVisible.value = true
  document.body.classList.add('modal-open')
}

function closeModal() {
  isModalVisible.value = false
  document.body.classList.remove('modal-open')
  emit('close')
}

async function refreshLookupDataCache() {
  try {
    const res = await fetch(props.baseUrl + 'AppData/GetAllLookupData', {
      method: 'GET',
      headers: authHeaders()
    })
    if (res.ok) {
      LookupDataService.saveData(await res.json())
    }
  } catch (e) {
    console.error('Failed to refresh lookup data:', e)
  }
}

async function addType() {
  const name = newTypeName.value.trim()
  if (!name) return

  errorMessage.value = ''
  isSaving.value = true
  try {
    const res = await fetch(props.baseUrl + 'EventTypes/Add', {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ Name: name })
    })
    const result = await res.json()
    if (res.ok && result.eventType) {
      newTypeName.value = ''
      await loadEventTypes()
      await refreshLookupDataCache()
      emit('changed')
    } else {
      errorMessage.value = result.responseMessage || 'Failed to add event type.'
    }
  } catch (e) {
    console.error(e)
    errorMessage.value = 'Failed to add event type.'
  } finally {
    isSaving.value = false
  }
}

function startEdit(type: any) {
  editingId.value = type.id
  editingName.value = type.name
}

async function updateType(type: any, name: string, active: boolean) {
  errorMessage.value = ''
  isSaving.value = true
  try {
    const res = await fetch(props.baseUrl + 'EventTypes/Update', {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify({ Id: type.id, Name: name, Active: active })
    })
    const result = await res.json()
    if (res.ok && result.eventType) {
      await loadEventTypes()
      await refreshLookupDataCache()
      emit('changed')
    } else {
      errorMessage.value = result.responseMessage || 'Failed to update event type.'
    }
  } catch (e) {
    console.error(e)
    errorMessage.value = 'Failed to update event type.'
  } finally {
    isSaving.value = false
  }
}

async function saveEdit(type: any) {
  await updateType(type, editingName.value.trim() || type.name, type.active)
  editingId.value = null
}

async function saveEditingType() {
  const type = eventTypes.value.find(t => t.id === editingId.value)
  if (type) {
    await saveEdit(type)
  }
}

async function toggleActive(type: any) {
  await updateType(type, type.name, !type.active)
}

__expose({ openModal })

return (_ctx: any,_cache: any) => {
  return (isModalVisible.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", {
          class: "modal-backdrop",
          onClick: closeModal
        }),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", { class: "modal-header" }, [
            _cache[2] || (_cache[2] = _createElementVNode("h3", null, "Manage Event Types", -1)),
            _createElementVNode("button", { onClick: closeModal }, "×")
          ]),
          _createElementVNode("div", _hoisted_3, [
            (errorMessage.value)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(errorMessage.value), 1))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newTypeName).value = $event)),
                type: "text",
                placeholder: "New event type name",
                onKeyup: _withKeys(addType, ["enter"])
              }, null, 544), [
                [_vModelText, newTypeName.value]
              ]),
              _createElementVNode("button", {
                class: "btn-add",
                disabled: isSaving.value || !newTypeName.value.trim(),
                onClick: addType
              }, "ADD", 8, _hoisted_6)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "table-header" }, [
                _createElementVNode("div", { class: "col-name" }, "Name"),
                _createElementVNode("div", { class: "col-active" }, "Active")
              ], -1)),
              (eventTypes.value.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, "No event types found"))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(eventTypes.value, (type) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: type.id,
                  class: "table-row"
                }, [
                  _createElementVNode("div", _hoisted_9, [
                    (editingId.value === type.id)
                      ? _withDirectives((_openBlock(), _createElementBlock("input", {
                          key: 0,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((editingName).value = $event)),
                          type: "text",
                          onKeyup: _withKeys(($event: any) => (saveEdit(type)), ["enter"])
                        }, null, 40, _hoisted_10)), [
                          [_vModelText, editingName.value]
                        ])
                      : (_openBlock(), _createElementBlock("span", {
                          key: 1,
                          onClick: ($event: any) => (startEdit(type))
                        }, _toDisplayString(type.name), 9, _hoisted_11))
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("input", {
                      type: "checkbox",
                      checked: type.active,
                      onChange: ($event: any) => (toggleActive(type))
                    }, null, 40, _hoisted_13)
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (editingId.value)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "btn-add",
                  disabled: isSaving.value,
                  onClick: saveEditingType
                }, "SAVE", 8, _hoisted_15))
              : _createCommentVNode("", true),
            _createElementVNode("button", {
              class: "btn-cancel",
              onClick: closeModal
            }, "CLOSE")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})